import gql from 'graphql-tag';

export const GETLISTEMPLEADOS = gql`
  query ($semIni:Int, $semFinal:Int, $ano:String){
    listaIdsEmpleadoSemana(semIni:$semIni, semFinal:$semFinal,ano:$ano)
  }
`;


export const GETLISTEMPLEADOSCALENDARIO = gql`
  query($inicio:String, $fin:String){
    listaIdEmpleadosCalendario(fechaInicio:$inicio,fechaFin:$fin)
  }
`;

export const GETLISTEMPLEADOSCALENDARIOXTIENDA = gql`
  query($inicio:String, $fin:String, $tienda:String){
    listaIdEmpledosCalendarioxTienda(fechaInicio:$inicio,fechaFin:$fin, tienda:$tienda)
  }
`;

export const GETINFOEMPLEADO = gql`
  query($empleado:String, $semIni:Int, $semFinal:Int, $ano:String){
    infoMetaEmpleado(empleado:$empleado,semIni:$semIni, semFinal:$semFinal,ano:$ano){
      empleado{
        id
        nombre
      }
      mallas{
        metaTotal
        tienda
        empleado
        semana
        meta{
          metaDia
        }
      }
      ventas{
        fecha
        cantidad
        vendedor
        tienda
        semana
      }
    }
  }
`;

export const GETINFOEMPLEADOCALENDARIO = gql`
  query($empleado:String, $semIni:String, $semFinal:String){
    infoMetaEmpleadoCalendario(empleado:$empleado,inicio:$semIni, fin:$semFinal){
      empleado{
        id
        nombre
        doc
        estado
        cargo{
          id
          cargo
        }
      }
      mallas{
        metaTotal
        tienda
        empleado
        semana
        meta{
          metaDia
          fecha
          esCompensado
        }
      }
      ventas{
        fecha
        cantidad
        vendedor
        tienda
        semana
        tipodoc
        articulos{
          valor
        }
      }
      pptoTienda
      ventasTienda
      tiendaMaestra
    cargo{
      _id
      idDB
      nombre
      negocio
      A{
        porcentajes{
          minimo
          maximo
          valor
        }
      }
      AA{
        porcentajes{
          minimo
          maximo
          valor
        }
      }
      AAA{
        porcentajes{
          minimo
          maximo
          valor
        }
      }
    }
  }
}
`;


export const GETINFOEMPLEADOCALENDARIOTIENDA = gql`
  query($empleado:String, $tienda:String $semIni:String, $semFinal:String){
    infoMetaEmpleadoCalendarioTienda(empleado:$empleado, tienda:$tienda, inicio:$semIni, fin:$semFinal){
      empleado{
        id
        nombre
        doc
        estado
        cargo{
          id
          cargo
        }
      }
      mallas{
        metaTotal
        tienda
        empleado
        semana
        meta{
          metaDia
          fecha
          esCompensado
        }
      }
      ventas{
        fecha
        cantidad
        vendedor
        tienda
        semana
        tipodoc
        articulos{
          valor
        }
      }
      pptoTienda
      ventasTienda
      cargo{
        _id
        idDB
        nombre
        negocio
        A{
          porcentajes{
            minimo
            maximo
            valor
          }
        }
        AA{
          porcentajes{
            minimo
            maximo
            valor
          }
        }
        AAA{
          porcentajes{
            minimo
            maximo
            valor
          }
        }
      }
    }
  }
`;

export const GETCOMISION = gql`
  query ($id: String){
    comision(id:$id){
      _id
      nombre
      fechaInicio
      fechaFin
    }
  }
`;

export const GETALLCOMISIONES = gql`
  query{
    comisiones{
      _id
      nombre
      fechaInicio
      fechaFin
    }
  }
`;

export const ADDCOMISION = gql`
  mutation($comision:String){
    addComision(comision:$comision)
  }
`;

export const ADDUPDATEEMPLECOMISION = gql`
  mutation($id:String, $data:String){
    addUpdateEmpleComision(id:$id, data:$data)
  }
`;


export const UPDATETIENDAMAESTRA = gql`
    mutation($idEmple:String, $tiendaMaestra:String, $observaciones:[String], $usuarioApro:[String], $fechas:[String]){
      actualizarTiendaEmpleComision(idEmple:$idEmple, tiendaMaestra:$tiendaMaestra, observaciones:$observaciones, usuarioApro:$usuarioApro, fechas:$fechas)
    }
`;

export const ELIMINARCOMISION = gql`
  mutation($id:String){
    eliminarComision(id:$id)
  }
`;

export const APROBARCOMISIONEMPLE = gql`
  mutation ($idemple:String, $usuario:[String], $aprobado:Boolean, $observaciones:[String], $fechas:[String]){
    aprobarComisionEmple(idemple:$idemple, usuarioApro:$usuario, aprobado:$aprobado, observaciones:$observaciones, fechas:$fechas)
  }
`;

export const ACTUALIZARCOMISIONEMPLE = gql`
  mutation ($idemple:String, $valor:Float, $observaciones:[String], $usuario:[String],  $fechas:[String]){
    actualizarEmpleadoComision(idemple:$idemple, valor:$valor, observaciones:$observaciones, usuarioApro:$usuario, fechas:$fechas)
  }
`;

export const ACTUALIZARCOMISIONEMPLEV2 = gql`
  mutation ($idemple:String, $valor:Float, $valorTienda:Float, $observaciones:[String], $usuario:[String],  $fechas:[String]){
    actualizarEmpleadoComisionV2(idemple:$idemple, valor:$valor, valorTienda:$valorTienda, observaciones:$observaciones, usuarioApro:$usuario, fechas:$fechas)
  }
`;

export const APROBARMANUALCOMISION = gql`
    mutation ($idemple:String, $observaciones:[String], $usuario:[String],  $fechas:[String]){
        aprobarManualEmpleadoComision(idemple:$idemple, observaciones:$observaciones, usuarioApro:$usuario, fechas:$fechas)
    }
`;

export const ELIMINARCOMISIONEMPLE = gql`
    mutation ($id:String){
        eliminarEmpleadoComision(id:$id)
    }
`;

export const LIQUIDARCOMISIONEMPLE = gql`
  mutation ($idemple:String, $valor:Float, $observaciones:[String], $usuario:[String], $fechas:[String]){
    liquidarEmpleadoComision(idemple:$idemple, valor:$valor, observaciones:$observaciones, usuarioApro: $usuario, fechas:$fechas)
  }
`;

export const GETEMPLEADOSCOMISION= gql`
  query($comision:String, $idUser:Int!){
    empleadoComision(comision:$comision, idUser:$idUser){
      _id
      empleado{
        nombre
        id
        doc
        estado
      }
      estado{
        paraAprobacion
        liquidado
      }
      observaciones
      cA{
        ventas
        meta
        cumplimiento
        valor
        diasProgramados
        diasCompensados
      }
      cAA{
        ventas
        meta
        cumplimiento
        valor
        diasProgramados
        diasCompensados
      }
      cAAA{
        ventas
        meta
        cumplimiento
        valor
        diasProgramados
        diasCompensados
      }
      totCat{
        ventas
        meta
        cumplimiento
        valor
        valorNeto
        diasProgramados
        diasCompensados
      }
    totTienda{
      ventas
      meta
      cumplimiento
      valor
      valorNeto
      diasProgramados
      diasCompensados
    }
      tiendas{
        id
        idDB
        nombre
        categoria
      }
      aprobado
      usuarioAprueba
      cargo{
        _id
        idDB
        nombre
      }
      mallas{
        meta{
          dia
          metaDia
          fecha
          esCompensado
        }
        tienda
        semana
        metaTotal
        empleado
      }
    fechaAprobacion
      ventas{
        fecha
        cantidad
        vendedor
        tienda
        semana
      }
      tiendaMaestra
    }
  }
`;


